<template>
  <div class="menu-desktop" id="menu">
    <a href="http://hihonor.com" target="_blank" class="logotype"></a>
    <a class="menu-item" v-on:click="scrollTo('products')">Products</a>
  	<a class="menu-item" v-on:click="scrollTo('community')">Community</a>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'menuDesktop',
  methods: {
    scrollTo (divId) {
      $('html, body').animate({
        scrollTop: $('#' + divId).offset().top - 40
      }, 'slow')
      if (window.ga) {
        window.ga('send', 'event', 'Menu', 'click', divId)
        window.ga('clientTracker.send', 'event', 'Menu', 'click', divId)
      }
    }
  },
  mounted () {
    window.onscroll = () => {
      let pos = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      let menu = document.getElementById('menu')
      if (pos > (window.innerHeight / 1.5) + 50) {
        menu.setAttribute('class', 'menu-desktop down')
      } else {
        menu.setAttribute('class', 'menu-desktop')
      }
    }
  },
  components: {}
}
</script>

<style scoped>
.logotype {
  display: inline-block;
  background-position: center left;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url('./../assets/img/logo.svg');
  width: 190px;
  height: 44px;
  margin-bottom: -12px;
  box-sizing: border-box;
}
.menu-desktop {
  position: fixed;
  padding: 12px;
  padding-left: 2vw;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.3);
  top: 0px;
  left: 0px;
  right: 0px;
  box-sizing: border-box;
  z-index: 999;
  -webkit-transition: all 600ms;
  transition: all 600ms;
}
.menu-desktop.down {
  background-color: rgba(0, 0, 0, 0.8);
  -webkit-transition: all 600ms;
  transition: all 600ms;
}
a.menu-item {
  height: 100%;
  display: inline-block;
  padding: 10px;
  padding-top: 13px;
  position: relative;
  top: 1px;
  font-size: 20px;
  box-sizing: border-box;
  margin-right: 18px;
}
a.menu-item:hover, a.menu-item.active {
  -webkit-transition: all 300ms;
  transition: all 300ms;
  color: #32bfe0 !important;
  border-color: #32bfe0 !important;
  cursor: pointer; 
}
</style>


// WEBPACK FOOTER //
// MenuDesktop.vue?4f00426d